import { Fragment } from "@wordpress/element";

const defaultView = () => {
    return (
        <Fragment>
        <div>
            <a href="https://superbthemes.com/plugins/superb-blocks/" target="_blank" rel="noopener noreferrer" style={{marginBottom:"10px",padding:"10px 20px",background:"#00bc87",color:"#fff",borderRadius:"3px",width:"100%",border:"0",cursor:"pointer",display:"block",textDecoration:"none",textAlign:"center"}}>Unlock Premium</a>
            <p>Buy the premium version and unlock additional features such as:</p>
            <ul style={{listStyle:"circle",paddingLeft:"20px"}}><li>Content Alignment</li><li>Text Color Customization</li><li>Element Color Customization</li><li>Font Size Customization</li></ul>
            <p><a href="https://superbthemes.com/plugins/superb-blocks/" target="_blank" rel="noopener noreferrer">Click here</a> or the button above to read more about Superb Blocks Premium including a full list of available blocks and features.</p>
        </div>
        </Fragment>
    )
}


export default defaultView;

export const defaultTitle = "Premium Features";

export const defaultPanel = () => {
    return (
        <Fragment>
        <div class="spb_upgrade"><p>Get premium & unlock all features</p> <a href="https://superbthemes.com/plugins/superb-blocks/" target="_blank" rel="noopener noreferrer">Read More</a></div>
        </Fragment>
    )
}